import { render, staticRenderFns } from "./SecondaryTable.vue?vue&type=template&id=4b80e016&scoped=true"
import script from "./SecondaryTable.vue?vue&type=script&lang=js"
export * from "./SecondaryTable.vue?vue&type=script&lang=js"
import style0 from "./SecondaryTable.vue?vue&type=style&index=0&id=4b80e016&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b80e016",
  null
  
)

export default component.exports